import portfolioImg01 from "../images/portfolio-01.jpg";
import portfolioImg02 from "../images/portfolio-02.jpg";
import portfolioImg03 from "../images/portfolio-03.jpg";
import portfolioImg04 from "../images/portfolio-04.jpg";
import portfolioImg05 from "../images/portfolio-05.jpg";
import portfolioImg06 from "../images/portfolio-06.jpg";
import portfolioImg07 from "../images/portfolio-07.jpg";

const portfolios = [
  {
    id: "01",
    imgUrl: portfolioImg01,
    category: "Web Design",
    title: "Food Delivery E-commerce Website",
    description:
      "This is my project in which i design this beautifull and complete responsive website through which anyone can easily use this website in mobile,tab ,computers and laptops ",
    technologies: ["React", "Tailwind css", "Node.js", "MongoDB","Material UI","Chakra js","Firebase","bootstrap","express js"],
    siteUrl: "https://food-delivery-ecommerce-app.netlify.app",
  },
  {
    id: "02",
    imgUrl: portfolioImg04,
    category: "Ux",
    title: "Multimart Ecommerce",
    description:
      "This is my project in which i design this beautifull and complete responsive website through which anyone can easily use this website in mobile,tab ,computers and laptops",
    technologies: ["React", "Tailwind css", "Node.js", "MongoDB","Material UI","Chakra js","Firebase","bootstrap","express js"],
    siteUrl: "https://multimart-ecommerce.netlify.app/",
  },
  {
    id: "03",
    imgUrl: portfolioImg02,
    category: "Ux",
    title: "Invoice App",
    description:
      "This is my project in which i design this beautifull and complete responsive website through which anyone can easily use this website in mobile,tab ,computers and laptops",
    technologies:  ["React", "Tailwind css", "Node.js", "MongoDB","Material UI","Chakra js","Firebase","bootstrap","express js"],
    siteUrl: "https://next-js-invoice-app.vercel.app/",
  },
  {
    id: "04",
    imgUrl: portfolioImg05,
    category: "Web Design",
    title: "NFT Marketplace Website",
    description:
      "This is my project in which i design this beautifull and complete responsive website through which anyone can easily use this website in mobile,tab ,computers and laptops",
    technologies: ["React", "Tailwind css", "Node.js", "MongoDB","Material UI","Chakra js","Firebase","bootstrap","express js"],
    siteUrl: "https://nft-marketplace-website.netlify.app",
  },
  {
    id: "05",
    imgUrl: portfolioImg03,
    category: "Web Design",
    title: "Digital Marketing Agency",
    description:
      "This is my project in which i design this beautifull and complete responsive website through which anyone can easily use this website in mobile,tab ,computers and laptops",
    technologies:  ["React", "Tailwind css", "Node.js", "MongoDB","Material UI","Chakra js","Firebase","bootstrap","express js"],
    siteUrl: "https://digency-marketing-agency.netlify.app/",
  },

  {
    id: "06",
    imgUrl: portfolioImg06,
    category: "Personal Portfolio Website",
    title: "Agency Website",
    description:
      "This is my project in which i design this beautifull and complete responsive website through which anyone can easily use this website in mobile,tab ,computers and laptops",
    technologies: ["React", "Tailwind css", "Node.js", "MongoDB","Material UI","Chakra js","Firebase","bootstrap","express js"],
    siteUrl: "https://webagency-website.netlify.app",
  },
  {
    id: "07",
    imgUrl: portfolioImg07,
    category: "Web Design",
    title: "Appointment Booking Website",
    description:
      "This is my project in which i design this beautifull and complete responsive website through which anyone can easily use this website in mobile,tab ,computers and laptops",
    technologies:  ["React", "Tailwind css", "Node.js", "MongoDB","Material UI","Chakra js","Firebase","bootstrap","express js"],
    siteUrl: "#",
  },
  {
    id: "08",
    imgUrl: portfolioImg01,
    category: "Web Design",
    title: "Restuarant Website",
    description:
      "This is my project in which i design this beautifull and complete responsive website through which anyone can easily use this website in mobile,tab ,computers and laptops",
    technologies:  ["React", "Tailwind css", "Node.js", "MongoDB","Material UI","Chakra js","Firebase","bootstrap","express js"],
    siteUrl: "https://restuarant-website-landing.netlify.app",
  },
  {
    id: "09",
    imgUrl: portfolioImg02,
    category: "Ux",
    title: "Video Conference Website",
    description:
      "This is my project in which i design this beautifull and complete responsive website through which anyone can easily use this website in mobile,tab ,computers and laptops",
    technologies:  ["React", "Tailwind css", "Node.js", "MongoDB","Material UI","Chakra js","Firebase","bootstrap","express js"],
    siteUrl: "#",
  },
  {
    id: "10",
    imgUrl: portfolioImg03,
    category: "Ux",
    title: "File Sharing Website",
    description:
      "This is my project in which i design this beautifull and complete responsive website through which anyone can easily use this website in mobile,tab ,computers and laptops",
    technologies: ["React", "Tailwind css", "Node.js", "MongoDB","Material UI","Chakra js","Firebase","bootstrap","express js"],
    siteUrl: "#",
  },
  {
    id: "11",
    imgUrl: portfolioImg04,
    category: "Web Design",
    title: "Landing Page",
    description:
      "This is my project in which i design this beautifull and complete responsive website through which anyone can easily use this website in mobile,tab ,computers and laptops",
    technologies:  ["React", "Tailwind css", "Node.js", "MongoDB","Material UI","Chakra js","Firebase","bootstrap","express js"],
    siteUrl: "#",
  },
  {
    id: "12",
    imgUrl: portfolioImg05,
    category: "Web Design",
    title: "Landing Page",
    description:
      "This is my project in which i design this beautifull and complete responsive website through which anyone can easily use this website in mobile,tab ,computers and laptops",
    technologies:  ["React", "Tailwind css", "Node.js", "MongoDB","Material UI","Chakra js","Firebase","bootstrap","express js"],
    siteUrl: "#",
  },
  {
    id: "13",
    imgUrl: portfolioImg06,
    category: "Web Design",
    title: "Online Therapy Website",
    description:
      "This is my project in which i design this beautifull and complete responsive website through which anyone can easily use this website in mobile,tab ,computers and laptops",
    technologies:  ["React", "Tailwind css", "Node.js", "MongoDB","Material UI","Chakra js","Firebase","bootstrap","express js"],
    siteUrl: "#",
  },
  {
    id: "14",
    imgUrl: portfolioImg07,
    category: "ux",
    title: "Appointment Booking Website",
    description:
      "This is my project in which i design this beautifull and complete responsive website through which anyone can easily use this website in mobile,tab ,computers and laptops",
    technologies: ["React", "Tailwind css", "Node.js", "MongoDB","Material UI","Chakra js","Firebase","bootstrap","express js"],
    siteUrl: "#",
  },
];

export default portfolios;